import { render, staticRenderFns } from "./UnitMSLNG2.vue?vue&type=template&id=54a1bb0d&scoped=true&"
import script from "./UnitMSLNG2.vue?vue&type=script&lang=js&"
export * from "./UnitMSLNG2.vue?vue&type=script&lang=js&"
import style0 from "./UnitMSLNG2.vue?vue&type=style&index=0&id=54a1bb0d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1bb0d",
  null
  
)

export default component.exports